import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { pageKeywords, pagePaths } from '../../../../constants/Page';
import { OutsourcerWorkerParams } from './Worker';

/**
 * 外注メンバリダイレクト
 * @returns
 */
const OutsourcerWorkerRedirect: React.FunctionComponent = () => {
  const params = useParams<OutsourcerWorkerParams>();

  return (
    <Navigate
      replace
      to={`${pagePaths.WORKER}/${params.outsourcerMemberId}/${pageKeywords.mode.VIEW}`}
    />
  );
};

export default OutsourcerWorkerRedirect;
